import React from 'react'

const Start = () => {
  return (<>
    <h1>Start</h1>
    <p>Get Content that Connects with Your Audience Every Time</p>
    <p>Actionable Copy that Fetches the Desired Results
Our network hosts the best professional copywriters who create content that leaves a lasting impression.</p>
<p>Actionable Copy that Fetches the Desired Results
Our network hosts the best professional copywriters who create content that leaves a lasting impression.</p>
    </>
  )
}

export default Start